import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptcha',
  initialState: false,
  reducers: {
    setEnableReCaptcha(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptcha } = slice.actions;

export default slice.reducer;
